<template>
  <div class="wrapper">
    <b-container class="wrapper" style="margin-top: -1rem; padding-bottom: 2rem">
      <b-row>
        <b-col class="mt-5" v-for="(item, index) in list" :key="index" cols="12" md="4">
          <div :class="lang == 'cn' ? 'mp-wrap':'enmp-wrap'">
          <!-- <div class="mp-wrap"> -->
            <img :src="item.photoUrl" />
            <p class="mpname">{{ item.name }}</p>
            <p class="itOne">
              <b style="display: none">概&nbsp;&nbsp;&nbsp;&nbsp;述：</b
              >{{ item.summary }}
            </p>
            <p class="itTwo">
              <b>{{$t('lang.Reward')}}</b>{{ item.bonus }}
            </p>
            <div class="donor">
              <h6>{{$t('lang.Donor')}}</h6>

              <p class="donorName">{{ item.donorName }}</p>
            </div>

            <router-link
              :to="'/nomination/award-rule?type=' + item.id"
              class="link"

              >{{$t('lang.Selectionrules')}}</router-link
            >
            <router-link :to="'/laureates/list?listBy=prize&name='+ item.name" class="link"
          
              >{{$t('lang.AllLaureates')}}</router-link
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      lang :''
    };
  },
  created() {
    this.lang = localStorage.getItem('LANG');
    // console.log(lang,'3333333333333');
    this.getAwardsList();
  },
  methods: {
    getAwardsList() {
      this.$api.awardsList().then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin-top: -1rem; 
  padding-bottom: 2rem
}
.mp-wrap {
  padding: 2rem;
  border: 0.1rem solid #eaeaea;
  color: #666666;
  img {
    width: 8rem;
    height: 8rem;
    display: block;
    margin: 0 auto;
  }
  .mpname {
    text-align: center;
    font-size: 1.2rem;
    color: #dbb979;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    min-height: 3rem;
  }
  .itOne {
    height: 5.14rem
  }
  .itTwo{
    height: 2rem
  }
  .link {
    width: 100%;
    height: 2.8rem;
    line-height: 2.8rem;
    display: block;
    margin-top: 0.8rem;
    text-align: center;
    color: #c8a063;
    font-size: 1rem;
    border: 0.1rem solid #d9bf91;
    border-radius: 0.3rem;
  }
  .link:hover{
    color: #fff!important;
    background-color: #c8a063;
  }
  .donor {
      height: 10.3rem;
    h6 {
      font-weight: 700;
    }
    p {
      margin: 0;
    }
    .donorName {
      white-space: pre-wrap;
    }
  }
  a {
      text-decoration: none;
  }
}

.enmp-wrap {
  padding: 2rem;
  border: 0.1rem solid #eaeaea;
  color: #666666;
  img {
    width: 8rem;
    height: 8rem;
    display: block;
    margin: 0 auto;
  }
  .mpname {
    text-align: center;
    font-size: 1.2rem;
    color: #dbb979;
    // margin-top: 0.5rem;
    // margin-bottom: 1rem;
    // min-height: 3rem;
    height: 3rem;
  }
  .itOne {
    height: 6.857rem
  }
  .itTwo{
    height: 1rem
  }
  .link {
    width: 100%;
    height: 2.8rem;
    line-height: 2.8rem;
    display: block;
    margin-top: 0.8rem;
    text-align: center;
    color: #c8a063;
    font-size: 1rem;
    border: 0.1rem solid #d9bf91;
    border-radius: 0.3rem;
  }
  .link:hover{
    color: #fff!important;
    background-color: #c8a063;
  }
  .donor {
      height: 14.6rem;
    h6 {
      font-weight: 700;
    }
    p {
      margin: 0;
    }
    .donorName {
      white-space: pre-wrap;
    }
  }
  a {
      text-decoration: none;
  }
}
@media (min-width: 768px) {
  .wrapper {
    min-width: 1200px;
    margin-top: -1rem; 
    padding-bottom: 6rem;
    .mpname{
      padding: 0 2rem;
    }
  }
}
</style>